import BarekamText from "../../text";
import BarekamButton, { DialogButtons } from "../../button";
import React from "react";
import Message from "../../message";
import { MessageSections } from "../../message/message";
import { DialogContentText } from "@mui/material";
import BarekamCheckbox from "../../checkbox";
import { WarningDialogContent } from "./styled";
import { DialogButtonContainer } from "../standard-dialog/styled";
import { StandardDialog } from "../standard-dialog/standard-dialog";

export const ConfirmationDialog = ({
    open,
    handleClose,
    titleKey,
    descriptionKey,
    isRemove,
    isWithCheckbox,
    checkboxTitle,
    handleCheckBoxValueChange
}: ConfirmationDialogProps) => {
   
    return (
        <StandardDialog headerLabel={<Message messageKey={titleKey} sectionId={MessageSections.MAIN} />}
            open={open}>
            <WarningDialogContent>
                <DialogContentText>
                    <Message messageKey={descriptionKey} sectionId={MessageSections.MAIN} />
                </DialogContentText>
            </WarningDialogContent>


            <DialogButtonContainer>
                {isWithCheckbox && (
                    <>
                        <BarekamText variant={"s"} opaque>
                            <Message messageKey={checkboxTitle} sectionId={MessageSections.MAIN} />
                        </BarekamText>
                        <BarekamCheckbox onClick={handleCheckBoxValueChange} />
                    </>
                )}

                <BarekamButton type={DialogButtons.CANCEL} onClick={() => handleClose(false)}>
                    <BarekamText variant={'s'} fontWeight={500} align={"center"}>
                        <Message messageKey={'cancel'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </BarekamButton>

                {isRemove
                    ? <BarekamButton type={DialogButtons.DELETE} onClick={() => handleClose(true)}>
                        <BarekamText variant={'s'} fontWeight={700} align={"center"}>
                            <Message messageKey={'delete'} sectionId={MessageSections.MAIN} />
                        </BarekamText>
                    </BarekamButton>
                    : <BarekamButton type={DialogButtons.OK} onClick={() => handleClose(true)}>
                        <BarekamText variant={'s'} fontWeight={700} align={"center"}>
                            <Message messageKey={'ok'} sectionId={MessageSections.MAIN} />
                        </BarekamText>
                    </BarekamButton>
                }
            </DialogButtonContainer>
        </StandardDialog>
    )
}

interface ConfirmationDialogProps {
    titleKey: string,
    descriptionKey: string,
    open: boolean,
    handleClose: (withChange: boolean) => void,
    isRemove?: boolean
    removingItemName?: string,
    isWithCheckbox?: boolean,
    checkboxTitle?: string,
    handleCheckBoxValueChange?: () => void
}